import { atom } from 'recoil';
import { EventDetail } from "common/types";

export const eventDetailData = atom<EventDetail>({
  key: 'EVENT_DETAIL_DATA',
  default: null
});